import { WeightMeasurement } from "@/model/transportorder/measurement"
import { WeightPresenter } from "../../Form/WeightPresenter"
import * as React from "react"
import { FormattedMessage } from "react-intl"
import { FormGroupWrapper } from "../../Form/FormGroupWrapper"
import { DangerousGoodsInformation, isDangerous } from "../../../model/transportorder/transportOrderDangerousGoods"
import { ReadOnlyDetailViewFormValue } from "../../Form/ReadOnlyDetailViewFormValue"
import { ReactElement } from "react"

export interface Props {
    value?: DangerousGoodsInformation
    netExplosiveMass?: WeightMeasurement,
}

export const DangerousGoodsPresenter = (props: Props): React.ReactElement => {
    const value = {
        isDangerous: isDangerous(props.value),
    }

    const singleWidthClassNames = "col-md-2 float-left-print width-20pct-print"
    const doubleWidthClassNames = "col-md-4 float-left-print width-40pct-print"
    const tunnelRestrictionCode = props.value?.tunnel_restriction_code ?
        `(${props.value?.tunnel_restriction_code})` : undefined

    return <>
        <div className="row">
            <div className={singleWidthClassNames}>
                <FormGroupWrapper
                    label={<FormattedMessage id={"transportOrder.dangerous_goods"}/>}
                    component={
                        <ReadOnlyDetailViewFormValue
                            data={value}
                            property={"isDangerous"}
                            formatProperty={(isDangerous: boolean): ReactElement => isDangerous
                                ? <FormattedMessage id={"yes"}/>
                                : <FormattedMessage id={"no"}/>
                            }/>
                    }
                />
            </div>
            <div className={singleWidthClassNames}>
                <FormGroupWrapper
                    label={<FormattedMessage id={"transportOrder.shipment.cargo.article.dangerousGoods.undgCode"}/>}
                    component={<ReadOnlyDetailViewFormValue
                        value={props.value?.undg_code}
                    />}
                />
            </div>
            <div className={singleWidthClassNames}>
                <WeightPresenter
                    weight={props.netExplosiveMass}
                    label={<FormattedMessage id="transportOrder.shipment.cargo.article.netExplosiveMass" />}
                />
            </div>
            <div className={singleWidthClassNames}>
                <FormGroupWrapper
                    label={<FormattedMessage id={"transportOrder.shipment.cargo.article.dangerousGoods.hazardClass"}/>}
                    component={<ReadOnlyDetailViewFormValue
                        value={props.value?.hazard_class}
                    />}
                />
            </div>
            <div className={singleWidthClassNames}>
                <FormGroupWrapper
                    label={<FormattedMessage id={"transportOrder.shipment.cargo.article.dangerousGoods.packingGroup"}/>}
                    component={<ReadOnlyDetailViewFormValue
                        value={props.value?.packing_group}
                    />}
                />
            </div>
        </div>
        <div className={"row"}>
            <div className={`${doubleWidthClassNames} word-break-all`}>
                <FormGroupWrapper
                    label={<FormattedMessage id={"transportOrder.shipment.cargo.article.dangerousGoods.description"}/>}
                    component={<ReadOnlyDetailViewFormValue
                        value={props.value?.description}
                    />}
                />
            </div>
            <div className={`${doubleWidthClassNames} word-break-all`}>
                <FormGroupWrapper
                    label={<FormattedMessage id={"transportOrder.shipment.cargo.article.dangerousGoods.exceptionRegulation"}/>}
                    component={<ReadOnlyDetailViewFormValue
                        value={props.value?.exception_regulation}
                    />}
                />
            </div>
            <div className={singleWidthClassNames}>
                <FormGroupWrapper
                    label={<FormattedMessage id={"transportOrder.shipment.cargo.article.dangerousGoods.tunnelRestrictionCode"}/>}
                    component={<ReadOnlyDetailViewFormValue
                        value={tunnelRestrictionCode}
                    />}
                />
            </div>
        </div>
    </>
}
